import { inject, Pipe, PipeTransform } from '@angular/core';
import { DATE_LOCALE, DateFormat, DateInput, formatDate } from '../i18n/date-format';

/**
 * Formats a date in the interface language, in place of Angular's `date` pipe:
 * `{{ sentAt | localizedDate: 'shortTime' }}` (see `DATE_FORMATS`).
 *
 * Impure so a language switch applies to views already on screen: every check
 * reads the `DATE_LOCALE` signal, which also refreshes the view after a
 * switch. It formats again only when the date, format or locale changed.
 */
@Pipe({ name: 'localizedDate', pure: false })
export class LocalizedDatePipe implements PipeTransform {
  readonly #locale = inject(DATE_LOCALE);
  #last?: { time: number; format: DateFormat; locale: string; text: string };

  transform(value: DateInput | null | undefined, format: DateFormat): string {
    const locale = this.#locale();
    const time = value == null || value === '' ? NaN : new Date(value).getTime();
    const last = this.#last;
    if (last && Object.is(last.time, time) && last.format === format && last.locale === locale) {
      return last.text;
    }
    const text = formatDate(time, format, locale);
    this.#last = { time, format, locale, text };
    return text;
  }
}
